import React from "react";
import { Card, CardContent } from "../../components/ui/card";

const StatCard = ({ label, value, delta, deltaType, icon }) => {
  const deltaColor = deltaType === "positive"
    ? "text-green-400"
    : deltaType === "negative"
      ? "text-red-400"
      : "text-muted-foreground";

  return (
    <Card className="border border-border">
      <CardContent className="pt-4 pb-3 px-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-2xl font-bold tracking-tight">{value}</p>
            <p className="text-xs text-muted-foreground mt-1">{label}</p>
          </div>
          {icon && <div className="text-muted-foreground">{icon}</div>}
        </div>
        {delta && (
          <p className={`text-xs mt-2 ${deltaColor}`}>{delta}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
